import { Component, OnInit,Renderer,ElementRef,  HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent implements OnInit {
  modalHeader: string;
  modalContent: string;
  target;
  showCancelButton = false;
  showSaveButton = false;
  public isBodyScrollable:boolean=false;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      if(!this.isBodyScrollable)
        this._renderer.setElementStyle(document.body, 'overflow', 'hidden');
      else{
        this._renderer.setElementStyle(document.body, 'overflow', 'unset');
      }
    }else{
      if(!this.isBodyScrollable)
        this._renderer.setElementStyle(document.body, 'overflow', 'hidden');
      else{
        this._renderer.setElementStyle(document.body, 'overflow', 'unset');
      }
    }
}
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private _renderer: Renderer,
    private eRef: ElementRef
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close();
    return false;
  }
  successModal() {
    console.log("clicked on ok");
    this.activeModal.close();
  }

  cancelModal() {
    console.log("clicked on abort");
    this.activeModal.close();
  }

  public ngOnDestroy():void{
    // this.isBodyScrollable = true;
    this._renderer.setElementStyle(document.body, 'overflow', 'unset');
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/alert-modal/alert-modal.component.ts